// extracted by mini-css-extract-plugin
export default {"input":"InputFile_input__lctM3","lite":"InputFile_lite__4G4+R","fileInput":"InputFile_fileInput__IPVuR","fileInputLabel":"InputFile_fileInputLabel__B0mNg"};